<template>
  <div class="wrap-hero">
    <div class="page-help content">
      <div class="wrapp-up">
        <div class="wrapp-text">
          <div class="title" v-html="$t('newHome.title')"></div>
          <div class="text" v-html="$t('newHome.text')"></div>
        </div>
        <div class="video">
          <!-- @click="$emit('changeShowVideo', true)" -->
          <img src="../../assets/newImges/play_video_replace.png" alt="play" />
        </div>
      </div>
      <div class="wrapp-btn">
        <router-link
          class="btn link"
          :to="{ name: 'Result', params: { lang: $i18n.locale } }"
          >{{ $t("newHome.seeSales") }}
          <img src="../../assets/newImges/arrowUpRight.svg" alt="go"
        /></router-link>

        <router-link
          class="ordinary-link"
          :to="{ name: 'Rules', params: { lang: $i18n.locale } }"
        >
          <img src="../../assets/newImges/folder_eye.svg" alt="go" />
          {{ $t("newHome.readRules") }}</router-link
        >
      </div>
    </div>
  </div>
</template>
<script>
export default {};
</script>
<style lang="scss" scoped>
.wrap-hero {
  font-family: Outfit;
  // min-height: 833px;
  max-height: fit-content;
  background-image: url("../../assets/newImges/background_linear.png") !important;
  background-size: cover;
  background-repeat: no-repeat;
  // background: linear-gradient(
  //   269.82deg,
  //   #efd2d7 5.72%,
  //   #e2afb8 57.01%,
  //   #87ceeb 108.29%
  // );

  .content {
    padding-top: 100px;
    padding-bottom: 236px;
    // background-color: aqua;
    text-align: left;

    .wrapp-up {
      display: flex;
      justify-content: space-between;
      margin-bottom: 72px;
      .wrapp-text {
        max-width: 880px;
        .title {
          font-weight: 700;
          font-style: Bold;
          font-size: 80px;
          // leading-trim: NONE;
          line-height: 114.99999999999999%;
          letter-spacing: 0%;
          max-width: 880px;
          margin-bottom: 24px;
        }
        .text {
          font-weight: 400;
          font-size: 24px;
          line-height: 32px;
          letter-spacing: 0%;
        }
      }
      .video {
        cursor: pointer;
        //new , delete when we get the video
        display: flex;
        align-items: center;
        margin-left: 10px;
        // new delete  END
        img:hover {
          opacity: 0.8;
        }
      }
    }
    .wrapp-btn {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      a {
        font-family: Outfit;
        font-weight: 400;
        font-style: Regular;
        font-size: 20px;
        line-height: 30px;
        letter-spacing: 0%;
      }
      .link {
        text-decoration: none;
        background-color: $blue-1000;
        color: #fff;
        min-width: 248px;
        img {
          margin-left: 15px;
        }
      }
      .ordinary-link {
        margin: 20px 0;
        margin-left: 54px;
        display: flex;
        align-items: center;
        text-decoration: none;
        color: $blue-1000;
        img {
          margin-right: 16px;
        }
      }
    }
  }
}

@media only screen and (max-width: 768px) {
  .wrap-hero {
    .content {
      padding-bottom: 136px;
      .wrapp-up {
        flex-direction: column;
        .wrapp-text {
          .title {
            font-size: 50px;
            // leading-trim: NONE;
            line-height: 100%;
          }
          .text {
            font-weight: 400;
            font-size: 18px;
            line-height: 24px;
          }
        }
        .video {
          margin: auto;
          margin-top: 30px;
          img {
            width: 300px;
          }
        }
      }
    }
  }
}
</style>
